module.exports = __webpack_public_path__ + "img/lpt.7f1fd959.svg";